export const ignoreErrors = [
  /Loading chunk [0-9]+ failed/,
  /JSONP request failed./,
  /We couldn't load ".*\/page-data\/.*\.json"/,
  /Non-Error promise rejection captured with value: Object Not Found Matching Id:[0-9]+/,
  /Failed to fetch/,
  /Illegal invocation/,
  /Can't find variable: Audio/,
  /e.toggleAttribute is not a function/,
  /Unexpected end of JSON input/,
  /Error: Unable to deserialize cloned data due to invalid or unsupported version./,
  /Failed to execute 'getBattery' on 'Navigator': Illegal invocation/,
  /Cannot convert 'window.sessionStorage' to object/,
  /Undefined variable: MutationObserver/,
  /CrossStorageClient could not connect/,
  /Invalid permissions for set/,
  /Timeout: could not perform cross-storage:set/,
  /ResizeObserver loop completed with undelivered notifications/,
  /ResizeObserver loop limit exceeded/,
  /Closing client. Could not access localStorage in hub./,
]
